import { render, staticRenderFns } from "./SingleCommentTextArea.vue?vue&type=template&id=de8475d6&scoped=true&"
import script from "./SingleCommentTextArea.vue?vue&type=script&lang=ts&"
export * from "./SingleCommentTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCommentTextArea.vue?vue&type=style&index=0&id=de8475d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8475d6",
  null
  
)

export default component.exports